import React from 'react'
import { BrowserRouter , Routes, Route } from 'react-router-dom'
import { Navbar, Sidebar, Footer } from './components'

import {Home,Products, SingleProduct, About, Cart,Error,Checkout,PrivateRoute} from './pages'



function App() {
  return (
<BrowserRouter>
  <Navbar/>
  <Sidebar/>
    <Routes>
      <Route exact path='/' element={<Home/>}/>
      <Route exact path='/checkout/*' element={<PrivateRoute><Checkout /></PrivateRoute>}/>
      <Route exact path='/about' element={<About/>}/>1
      <Route exact path='/cart' element={<Cart/>}/>
      <Route exact path='/products' element={<Products/>}/>
      <Route exact path='/products/:id' element={<SingleProduct/>}/>
      <Route path='*' element={<Error/>}/>
    </Routes>
    <Footer/>

</BrowserRouter>

  )}
export default App
